// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HryS","requiredAsterisk":"Info_requiredAsterisk__2DmUy"};